import { MAX_SAFE_INTEGER } from './internals/native.js';

function isLength(value) {
    return typeof value === 'number' && value > -1 && value % 1 === 0 && value <= MAX_SAFE_INTEGER;
}

export { isLength as default };
